import { useLayoutEffect } from 'react'
import { useGetMyInformationQuery } from '../../common/graphql/__generated__/graphql.autogenerated'
import useCustomerInformation from './useCustomerInformation'

// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const useGetMyInformation = () => {
  const [customerInformation, setCustomerInformation] = useCustomerInformation()
  const { firstName, lastName } = customerInformation
  const { data, loading, error, refetch } = useGetMyInformationQuery({
    fetchPolicy: 'no-cache',
    skip: !!lastName || !!firstName,
  })

  useLayoutEffect(() => {
    if (!loading && data?.myAccount.currentUser) {
      setCustomerInformation(data.myAccount.currentUser)
    }
  }, [loading, data])

  return {
    data,
    loading,
    error,
    refetch,
  }
}

export default useGetMyInformation
